// extracted by mini-css-extract-plugin
module.exports = {"c-link-default":"_025a50318d--c-link-default--3PDtU"};